import { Component, AfterViewInit, OnInit } from '@angular/core';
import { FilterService, ProviderModel } from "../core/services/index";
import { DropdownValue } from "../shared/dropdown.model";
import { FormControl } from "@angular/forms";
import { SortModel } from "../shared/sort.model";

@Component({
    moduleId: module.id,
    templateUrl: 'providers.component.html'
})

export class ProvidersComponent implements OnInit, AfterViewInit {
    providers: Array<ProviderModel>;
    private _providers: Array<ProviderModel>;
    pageNumber: number = 1;
    totalCount: number;
    useLightClass: boolean = true;
    filterName = new FormControl();
    nameSort: SortModel = new SortModel(1, SortModel.ascIcon);
    private nameFilter: string = '';
    private sortField: SortModel;
    private sortDirectionAsc: boolean = true;

    constructor(private filterService: FilterService) {
    }

    ngOnInit(){
        this.sortField = this.nameSort;
        this.filterName.valueChanges
            .debounceTime(500)
            .distinctUntilChanged()
            .subscribe((filter: string) => {
                this.nameFilter = filter.trim();
                this.getProviders(1);
            });
    }

    getProviders(page: number) {
        if (!this._providers)
            this._providers = this.filterService.getProviders();
        if (this.nameFilter.length > 0)
            this.providers = this._providers.filter(s => s.name.toLowerCase().indexOf(this.nameFilter.toLowerCase()) > -1);
        else
            this.providers = this._providers;
        this.providers = this.providers.sort((a: ProviderModel, b: ProviderModel) => {
            if (a.name < b.name) return this.sortDirectionAsc == true ? -1 : 1;
            if (a.name > b.name) return this.sortDirectionAsc == true ? 1 : -1;
            return 0;
        });
        this.totalCount = this.providers.length;
    }

    onPageSizeChanged(item: DropdownValue) {
        this.getProviders(this.pageNumber);
    }

    onSortChanged(sort: SortModel) {
        if (sort === this.sortField) {
            if (sort.selectedOrder === SortModel.ascIcon) {
                sort.selectedOrder = SortModel.descIcon;
                this.sortDirectionAsc = false;
            }
            else {
                if (sort.selectedOrder === SortModel.descIcon) {
                    sort.selectedOrder = SortModel.ascIcon;
                    this.sortDirectionAsc = true;
                }
            }
        }
        else {
            this.sortField.selectedOrder = SortModel.disabledIcon;//disable the previous
            sort.selectedOrder = SortModel.ascIcon;
            this.sortField = sort;
        }
        this.getProviders(1);
    }

    ngAfterViewInit() {
        this.getProviders(this.pageNumber);
    }
}


// WEBPACK FOOTER //
// ./src/app/providers/providers.component.ts